"use client";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { fontOptions } from "@/lib/fonts";
import { cn } from "@/lib/utils";

interface FontPickerProps {
  value: string;
  onChange: (id: string) => void;
}

export function FontPicker({ value, onChange }: FontPickerProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v)}
      className="grid w-full grid-cols-2 gap-2"
    >
      {fontOptions.map((font) => (
        <ToggleGroupItem
          key={font.id}
          value={font.id}
          aria-label={font.label}
          className={cn(
            "flex h-auto flex-col items-center gap-1 rounded-lg border bg-card px-2 py-3 data-[state=on]:border-primary data-[state=on]:bg-accent data-[state=on]:text-accent-foreground"
          )}
        >
          <span
            className="text-2xl leading-none"
            style={{ fontFamily: font.family, fontWeight: font.weight }}
          >
            Aa
          </span>
          <span className="text-[11px] text-muted-foreground">
            {font.label}
          </span>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
